import React from 'react';

interface ISelectedCheckProps {
  className?: string;
}

export default function SelectedCheck({
  className = ''
}: ISelectedCheckProps) {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="38"
        height="38"
        rx="19"
        fill="#e59400"
      />
      <path
        d="M10 17.9707L16.373 24L28 13"
        stroke="#362b24"
        strokeWidth="2"
      />
    </svg>
  );
}

